'use strict';

import angular from 'angular';

export default class MemPersonalCtrl {
  constructor($stateParams, ToastrSvc, MemberSvc) {
    var that = this;
    var groupId = $stateParams.ctxId; // use context group

    this.personalFields = [
      {display: 'Prefix', attribute: 'prefix'},
      {display: 'First Name', attribute: 'fname'},
      {display: 'Preferred Name', attribute: 'preferredName'},
      {display: 'Middle Name', attribute: 'mname'},
      {display: 'Last Name', attribute: 'lname'},
      {display: 'Suffix', attribute: 'suffix'},
      {display: 'Gender', attribute: 'gender'},
      {display: 'Birth Day', attributes: [
        {attribute: 'birthmonth', map: 'displayMonth'},
        {attribute: 'birthday', max: 31}
      ]},
      {display: 'Birth Year', attribute: 'birthyear'},
      // {display: 'Deceased', attribute: 'deceased'} // hard coded into view
    ];
    // display mappings
    this.maps = {displayMonth: {
      0: 'January', 1: 'February', 2: 'March', 3: 'April',
      4: 'May', 5: 'June', 6: 'July', 7: 'August',
      8: 'September', 9: 'October', 10: 'November', 11: 'December'
    }};

    this.model = {};
    this.edit = function(person) {
      that.person = person; // set person
      that.model = angular.copy(person);
      if(typeof that.model.birthmonth === 'number') {
        that.model.birthmonth = that.model.birthmonth.toString();
      }
      that.showForm = true;
    };

    this.view = function() {
      // refresh form model
      if(that.person) { that.model = angular.copy(that.person); }
      that.showForm = false;
    };

    this.cancel = this.view;

    // this.model set in parent UserCtrl
    this.submit = function(errorCb) {
      var person = that.model;
      if(typeof person.birthmonth === 'string') {
        person.birthmonth = Number(person.birthmonth);
      }
      MemberSvc.updatePerson({groupId, id: person.id}, person).$promise
        .then(function(res) {
          angular.extend(that.person, res.toJSON());
          that.showForm = false;
          ToastrSvc.success('User Personal Information Updated');
        })
        .catch(errorCb);
    };
  }
}

MemPersonalCtrl.$inject = ['$stateParams', 'ToastrSvc', 'MemberSvc'];
